import "./lib/reactQuillShim";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { ThemeProvider } from "./theme";
import { AuthProvider } from "./contexts/AuthContext";
import { PushNotificationService } from "./services/pushNotifications";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

console.log("Build: v3.0.0-" + Date.now());

// Register Service Worker for PWA caching + push notifications
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('[SW] Registered successfully:', registration.scope);

        // Force immediate update check on each page load
        registration.update();
        
        // Initialize push notifications
        PushNotificationService.initializeServiceWorker().then(() => {
          console.log('[PushNotifications] Initialized');
        });
        
        // Check for updates every 60 seconds
        setInterval(() => {
          registration.update();
        }, 60000);

        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                console.log('[SW] New version available, activating immediately');
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });

        // Reload once when the newly activated SW takes control
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (sessionStorage.getItem('whipt_sw_reloaded') === '1') return;
          sessionStorage.setItem('whipt_sw_reloaded', '1');
          window.location.reload();
        });
      })
      .catch((error) => {
        console.error('[SW] Registration failed:', error);
      });
  });
}

// AUTO-PURGE ENABLED - Cache clears automatically on every deployment! 🎉
